import React from 'react';
import { CodeBlock } from 'react-code-block';
import { useCopyToClipboard } from 'react-use';
import '@fortawesome/fontawesome-svg-core/styles.css';
import YouTube from "react-youtube";

function LegoL53AComponent({ code, language }) {
    code = `{/* L53 Bullet List */}
                                            <div className="lego l053 smallFont">
                                                <ul className="w-100">
                                                    <li className="w-100">Stop or reduce pain.</li>
                                                    <li className="w-100">Improve function.</li>
                                                    <li className="w-100">Reduce the number of pain medications taken.
                                                    </li>
                                                    <li className="w-100">Avoid or delay surgery.</li>
                                                </ul>
                                            </div>
                                            {/* End L53 Bullet List */}`;
    language = 'jsx';
    const [state, copyToClipboard] = useCopyToClipboard();

    const copyCode = () => {
        // Logic to copy `code`
        copyToClipboard(code);
    };

    return (
        <CodeBlock code={code} language={language}>
            <div className="relative">
                <CodeBlock.Code className="bg-black">
                    <div className="table-row">
                        <CodeBlock.LineNumber className="table-cell pr-4 text-sm text-gray-500 text-right select-none" />
                        <CodeBlock.LineContent className="table-cell">
                            <CodeBlock.Token />
                        </CodeBlock.LineContent>
                    </div>
                </CodeBlock.Code>
                <div className="buttonContainer">
                    <button className="btn btn-primary ml-auto" onClick={copyCode}>
                        <i className="fa-solid fa-copy"></i> {state.value ? 'Copied!' :  'Copy code'}
                    </button>
                </div>
            </div>
        </CodeBlock>
    );
}

export default LegoL53AComponent;